import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import AddStudentsToClassForm from "../../components/Forms/AddStudentsToClassForm";

class AddStudentsToClass extends Component {
 
  render() {
    return (
      <Modal size="lg" isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader>Lägg till elever i klassen</ModalHeader>
        <ModalBody>
          <AddStudentsToClassForm
            loadstudents={this.props.loadstudents}
            classId={this.props.classId}
            dismissModal={this.props.toggle}
            students={this.props.students}
            existingStudents={this.props.existingStudents}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default AddStudentsToClass;
